import React from "react";
import WalletConnectControl from "./WalletConnectControl";

const baseStyle = {
  padding: 16,
  width: "100%",
  boxSizing: "border-box",
  minWidth: 0,
  display: "flex",
  alignItems: "center",
  justifyContent: "center",
};

export default function WalletConnectPrompt({ style = null }) {
  return (
    <div style={{ ...baseStyle, ...(style || {}) }}>
      <WalletConnectControl />
    </div>
  );
}
